/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class StreamReaderAdapter {
  constructor(streamReader) {
    this.streamReader = streamReader;
  }

  read = () =>
    new Promise((resolve, reject) => {
      if (!this.streamReader) {
        reject("StreamReader not found to read data from");
        return;
      }

      this.streamReader
        .read()
        .then(({ value, done }) => {
          if (done) {
            resolve({ hasData: !done });
            return;
          }

          value
            .then(response => {
              const { data } = response;
              if (data) {
                const { html } = data;
                if (html) {
                  const htmlChunk = this.lastHTML ? html.slice(this.lastHTML.length) : html;
                  this.lastHTML = html;

                  resolve({ hasData: !done, data: htmlChunk });
                  return;
                }
                reject("Chunk received from AJS does not have html");
              }
              reject("Chunk received from AJS does not have data");
            })
            .catch(e => reject(e));
        })
        .catch(e => reject(e));
    });
}

export default StreamReaderAdapter;
